const { cELM, unique } = require("../../utils");
const MultiSelect = require("../options/multi-select");
const MultiSelectV2 = require("../options/multi-select-v2");
const SingleSelect = require("../options/single-select");
const SingleSelectInsurance = require("../options/single-select-insurance");
const SingleSelectOther = require("../options/single-select-other");
const SingleSelectObject = require('../options/single-select-object');
const ButtonClick = require("../options/button-click");
const TextInput = require("../options/text-input");
const PhoneInput = require("../options/phone-input");
// const AddressInput = require("../options/address-input");
const AddressInput = require("../options/address2-input");
const BloodPressureInput = require("../options/blood-pressure-input");
const BloodPressureInputV2 = require("../options/blood-pressure-input-v2");
const DobInput = require("../options/dob-input");
const CreditCardInput = require("../options/credit-card-input");
const SignatureInput = require("../options/signature-input");
const TimeInput = require("../options/time-input");
const HeightInput = require("../options/height-input");
const AutoCompleteInput = require("../options/autocomplete-input");
const Phq = require("../options/phq");
const SsnInput = require("../options/ssn-input");
const List = require("../options/list");
const ListYESNO  = require("../options/list-yes-no");
const Confirm = require("../options/confirm");
const EmailInput = require('../options/valid-email-input');
const AutoCompleteInputInsurance = require('../options/autocomplete-insurance');
const MoneyInput = require('../options/money-input');
const CameraRequest = require('../options/camera-request');
const Calendar = require('../options/calendar-input');
const SingleSelectAdvanced = require('../options/single-select-advanced');
const CallClient = require('../options/call-client');
const MultiSelectObject = require("../options/multi-select-object");
const YesNoTranslated = require('../options/yes-no-translated');
const ContinueArrow = require('../options/continue-arrow');

const Chat = require("../../chat");
const DoubleTextInput = require("../options/double-text-input");
const CollabProvidersCalendar = require("../options/collab-providers-calendar");

class Option {
  constructor(params) {
    this._params = params;
    this._data = params.data;
    this._element = this.createElement(this);
  }

  createElement(_self) {
    const requiredValidator = value => {
      return value && value.length > 0;
    };
    // const phoneValidator = (value) => { return value && value.length > 0};
    // const emailValidator = (value) => { return value && value.length > 0};

    switch (_self._data.format) {
      case "yes/back-translated":
      case "yes/no-translated":
        return new YesNoTranslated(_self._data, _self._data.onAnswer);
      case "yes/no":
        return new ButtonClick(_self._data, _self._data.onAnswer);
      case "yes/no/skip":
      case "yes/no-back":
      case "yes/no-back-2":
      case "yes/no-back-3":
      case "yes/back":
      case "info-card":
      case "continue":
        return new ButtonClick(_self._data, _self._data.onAnswer);
      case "multiselect":
        return new MultiSelect(this._data);
      case "multiselect-v2":
        return new MultiSelectV2(_self._data);
      case 'multiselect-object':
        return new MultiSelectObject(_self._data);
      case "info-card-v2":
        return new SingleSelectObject(this._data);
      case "singleselect":
      case "welcome/language":
        return new SingleSelect(this._data);
      case "singleselect-other":
        return new SingleSelectOther(
          this._data
        );
      case "singleselect-insurance":
        return new SingleSelectInsurance(
          this._data
        );
      case 'singleselect-object':
        return new SingleSelectObject(this._data);
      case "date":
        return new DobInput(_self._data);
      case "time":
        return new TimeInput(_self._data);
      case "legal-name":
        return new TextInput(_self._data, getLngTxt("input.placeholder.name"));
      case "double-text-input":
          return new DoubleTextInput(this._data, requiredValidator);
      case "text":
      case "other":
        return new TextInput(this._data, getLngTxt("input.placeholder.type"), "text", requiredValidator);
      case "schedule-date":
        return this._data.isCollabProvidersView ? new CollabProvidersCalendar(this._data) : new Calendar(this._data);
      case "provider-select":
      case "department-select":
      case "reason-of-visit":
      case "provider-select-v2":
      case "department-select-v2":
      case "reason-of-visit-v2":
        return new SingleSelectAdvanced(this._data);
      case "continue-arrow":
        return new ContinueArrow(this._data);
      case "callclient":
        return new CallClient(this._data);
      case "ssn":
        return new SsnInput(this._data);
      case "array": //AR: types are are in values
        if (_self._data && _self._data.values && _self._data.values.indexOf("|") > -1) {
          return new SingleSelect(this._data);
        } else if (_self._data.values === "medication") {
          return new AutoCompleteInput(this._data);
        } else {
          const params = _self._data;
          params.format = _self._data.values || "text";
          return this.createElement(_self);
        }
      case "medication":
      case "search":
      case "autocomplete":
        return new AutoCompleteInput(this._data);
      case "search-insurance":
        return new AutoCompleteInputInsurance(this._data);
      case "zipcode":
      case "number":
      case "number-auto":
        return new TextInput(this._data, getLngTxt("input.placeholder.number"), "number", requiredValidator);
      case "weight":
        return new TextInput(this._data, getLngTxt("input.placeholder.number.add"), "number", requiredValidator);
      case "money":
        return new MoneyInput(this._data, this._data.placeholder || getLngTxt("input.placeholder.money"), requiredValidator);
      case "height":
      case "ppl-height":
        return new HeightInput(this._data);
      case "tel":
        const phoneValidator = value => {
          return value && value.length > 0;
        };
        return new PhoneInput(this._data, getLngTxt("input.placeholder.tel"), requiredValidator);
      case "email":
        const emailValidator = value => {
          if (!value || value.length === 0) return false;
          if (!value.includes("@") || !value.includes(".")) return false;
          if (value.indexOf("@") >= value.indexOf(".")) return false;
          // basic email validation, as i cannot use regex.
          return true;
        };
        return new TextInput(this._data, getLngTxt("input.placeholder.email"), "email", requiredValidator);
      case "valid-email":
        return new EmailInput(this._data, getLngTxt("input.placeholder.email"), "email", requiredValidator);
      case "address":
      case "address-entity":
        return new AddressInput(this._data);
      case "blood-pressure":
        return new BloodPressureInput(this._data);
      case "blood-pressure-v2":
        return new BloodPressureInputV2(this._data);
      case "dob":
        return new DobInput(this._data);
      case "signature":
        return new SignatureInput(this._data);
      case "phq":
        return new Phq(this._data.buttons, this._data.callback);
      case "creditcard":
        return new CreditCardInput(this._data);
      case "list":
        return new List(this._data)
      case "list-yes-no":
        return new ListYESNO(this._data)
      case "confirm":
        return new Confirm(_self._data, _self._data.onAnswer);
      case "camera-request":
        return new CameraRequest(_self._data);
      default:
        // console.warn(this._data);
        return null;
    }
  }

  getHTML() {
    return this._element;
  }

  getELM() {
    return this._element.getELM();
  }

  updateAnswer(value, parentEl, callback) {
    const self = this;
    const optionEl = parentEl.lastChild;
    // optionEl.style.display = "none";
    this.animateHideRemove(optionEl);

    const answerEl = cELM("div", "option-block answer");

    const onEditClicked = function(evt) {
      confirmPop(
        {
          title: getLngTxt("popup.edit.title"),
          content: getLngTxt("popup.edit.content"),
        },
        function(isConfirmed) {
          if (isConfirmed) {
            Chat.default.edit({ id: value.id, text: value.text });
            parentEl.removeELM(answerEl);
            optionEl.style.display = "flex";

            callback && callback(self._data.id, parentEl);
            // Chat.default.BOT.clearAfterId(self._data.id);
            self._element && self._element.reset && self._element.reset();
          } else {
          }
        },
      );
    };

    //AR: we only want editing of the button not the entire block
    const _el = cELM("div", "button edit edit-active", getLngTxt("button.edit"));
    _el.onclick = onEditClicked;

    if (this._data.format === "signature") {
      const _imgEl = cELM("image");
      _imgEl.src = value.text;
      answerEl.addELM(_imgEl);
      answerEl.addELM(_el);
    } else if (this._data.format === "address" || this._data.format === "address-entity") {
      answerEl.addELM(cELM("div", "button button-active", value.text.content || value.data));
      if (value.canEdit) {
        answerEl.addELM(_el);
      }
    } else if (this._data.format === "text") {
      answerEl.addELM(cELM("div", "button button-active", value.text));
      if (value.canEdit) {
        answerEl.addELM(_el);
      }
    } else {
      if (value.text) {
        const answerArray = Array.isArray(value.text.selectedOptions)
          ? value.text.selectedOptions.map(option => option.name || option.value)
          : value.text.split(", ");

        if (answerArray.length > 1) {
          answerArray.forEach(aa => {
            answerEl.addELM(cELM("div", "button button-active", aa));
          });
          if (value.canEdit || this._data.showDefaultUI) {
            answerEl.addELM(_el);
          }
        } else {
          const elemValue = Array.isArray(value.text.selectedOptions)
            ? answerArray[0]
            : value.text;

          answerEl.addELM(cELM("div", "button button-active", elemValue));
          if (value.canEdit || this._data.showDefaultUI) {
            answerEl.addELM(_el);
          }
        }
      } else {
        answerEl.addELM(_el);
      }
    }

    parentEl.addELM(answerEl);
  }

  focus() {
    if (this._element) {
      this._element.focus();
    }
  }

  animateHideRemove(el) {
    el.style.display = "none";
  }
}

module.exports = Option;
